<template>
  <v-content>
    <show-at breakpoint="mediumAndBelow">
      <carousel
        :per-page="1"
        :touch-drag="touchFlip"
        :navigate-to="1"
        :pagination-enabled="false"
      >
        <slide>
          <hide-at breakpoint="small">
            <cmsismaillarge
              v-if="mountedChild"
              @location="location"
              style="padding: 0; margin: 0"
            >
            </cmsismaillarge>
          </hide-at>
          <show-at breakpoint="small">
            <cmsismailsmall
              v-if="mountedChild"
              @location="location"
              style="padding: 0; margin: 0"
            >
            </cmsismailsmall>
          </show-at>
        </slide>
        <slide>
          <v-content class="ma-0 pa-0">
            <viewer
              :bus="bus"
              class="ma-0 pa-0"
              v-if="mountedChild"
              ref="viewerRef"
            >
            </viewer>
            <v-btn
              icon
              @click="lockFlip()"
              class="ml-n4"
              style="position: absolute; top: 50%; left: 0"
              ><v-icon size="50">mdi-power-on</v-icon></v-btn
            >
          </v-content>
        </slide>
      </carousel>
    </show-at>
    <hide-at breakpoint="mediumAndBelow" id="hhh">
      <splitpanes>
        <pane
          max-size="50"
          :size="changeSize"
          style="font-size: 1em; font-family: Raleway Nunito Sans"
        >
          <v-content>
            <cmsismaillarge
              v-if="mountedChild"
              @location="location"
              style="padding: 0; margin: 0"
            >
            </cmsismaillarge>
          </v-content>
        </pane>
        <pane
          min-size="50"
          :size="changeSize1"
          class="ma-0 pa-0"
          style="font-size: 1em; font-family: Raleway Nunito Sans"
        >
          <v-content class="ma-0 pa-0">
            <viewer
              :bus="bus"
              class="ma-0 pa-0"
              v-if="mountedChild"
              ref="viewerRef"
            >
            </viewer>

            <double-click
              @single-click="minMaxViewWidth()"
              @double-click="toggleViewWidth()"
            >
              <v-card
                class="ml-2 hoverr"
                width="7"
                height="60"
                color="grey"
                id="hh"
                rounded="xl"
                @mousedown="gghh"
                style="
                  position: absolute;
                  top: 43%;
                  left: 0;
                  cursor: col-resize;
                  hover: red;
                "
              ></v-card>
            </double-click>

            <!--
            <v-btn
              id="hh"
              @mousedown="gghh"
              style="
                position: absolute;
                top: 50%;
                left: 0;
                cursor: col-resize;
                hover: red;
              "
              icon
            >
              <v-icon size="65" class="ml-n13">mdi-card</v-icon>
            </v-btn>
            -->
          </v-content>
        </pane>
      </splitpanes>
    </hide-at>
  </v-content>
</template>
<script>
import { showAt, hideAt } from "vue-breakpoints";
import { Carousel, Slide } from "vue-carousel";
import viewer from "../components/viewer";
import cmsismaillarge from "../components/cmsismaillarge";
import cmsismailsmall from "../components/cmsismailsmall";
import DoubleClick from "../components/doubleClick";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import Vue from "vue";

import { longClickDirective } from "vue-long-click";
const longClickInstance = longClickDirective({ delay: 150, interval: 50 });
Vue.directive("longclick", longClickInstance);

var xDirection = "";
var yDirection = "";

var oldX = 0;
var oldY = 0;

export default {
  name: "Augmentable",
  components: {
    Carousel,
    Slide,
    showAt,
    hideAt,
    cmsismaillarge,
    cmsismailsmall,
    DoubleClick,
    viewer,
    Splitpanes,
    Pane,
  },

  data: function () {
    return {
      locationGLB: "",
      fileID: "",
      touchFlip: true,
      bus: new Vue(),

      changeSize: "50",
      changeSizeMin: "30",

      changeSize1: "50",
      changeSizeMax: "70",
      fullViewer: false,
      minMaxViewer: false,

      //to mount the child components when parent is mounted already
      mountedChild: false,
    };
  },

  beforeRouteUpdate: function (to, from, next) {
    console.log(to);
    console.log(from.path);
    let pathPre = from.path.split("/");
    if (pathPre[1] === "changespot") {
      var child = this.$refs.viewerRef;
      child.updatedTasksData();
      //this.updatedTasksData();
    }
    next();
  },

  mounted() {
    this.mountedChild = true;
  },

  methods: {
    location(e, f) {
      this.fileID = f;
      this.locationGLB = e;

      this.bus.$emit("location1", this.locationGLB, this.fileID);

      //this.$emit("location", this.locationGLB, this.fileID);
    },
    augMethod() {},
    lockFlip() {
      this.touchFlip = !this.touchFlip;
      console.log("gjhgjhgjhgjhgjh");
    },
    changeValue(x) {
      console.log(x + 1);
    },
    ghgh(e) {
      if (oldX < e.pageX) {
        xDirection = "right";

        if (this.changeSize === "0") {
          this.fullViewer = false;
          this.changeSize = "30";
          this.changeSize1 = "70";
        }

        if (this.changeSize < "50") {
          this.changeSize1 = (parseInt(this.changeSize1) - 1).toString();
          this.changeSize = (parseInt(this.changeSize) + 1).toString();
        }
      } else {
        xDirection = "left";

        if (this.changeSize > "30") {
          this.changeSize1 = (parseInt(this.changeSize1) + 1).toString();
          this.changeSize = (parseInt(this.changeSize) - 1).toString();
        }
      }

      //deal with the vertical case
      if (oldY < e.pageY) {
        yDirection = "down";
      } else {
        yDirection = "up";
      }

      oldX = e.pageX;
      oldY = e.pageY;

      console.log(xDirection + " " + yDirection);
    },

    gghh(e) {
      document.getElementById("hhh").addEventListener("mousemove", this.ghgh);

      document
        .getElementById("hhh")
        .addEventListener("mouseup", this.removeListener);

      // if (oldX < e.pageX) {
      //   xDirection = "right";
      //   if (this.changeSize < "50") {
      //     this.changeSize1 = (parseInt(this.changeSize1) - 1).toString();
      //     this.changeSize = (parseInt(this.changeSize) + 1).toString();
      //   }
      // } else {
      //   xDirection = "left";
      //   if (this.changeSize > "30") {
      //     this.changeSize1 = (parseInt(this.changeSize1) + 1).toString();
      //     this.changeSize = (parseInt(this.changeSize) - 1).toString();
      //   }
      // }

      // //deal with the vertical case
      // if (oldY < e.pageY) {
      //   yDirection = "down";
      // } else {
      //   yDirection = "up";
      // }

      // oldX = e.pageX;
      // oldY = e.pageY;
      console.log(e);
      // console.log(xDirection + " " + yDirection);
    },
    removeListener() {
      document
        .getElementById("hhh")
        .removeEventListener("mousemove", this.ghgh);
    },
    toggleViewWidth() {
      if (this.fullViewer === false) {
        this.fullViewer = true;
        this.minMaxViewer = true;
        this.changeSize = "0";
        this.changeSize1 = "100";
      } else {
        this.minMaxViewer = false;
        this.fullViewer = false;
        this.changeSize = "50";
        this.changeSize1 = "50";
      }
    },
    minMaxViewWidth() {
      if (this.minMaxViewer === false) {
        this.fullViewer = true;
        this.minMaxViewer = true;
        this.changeSize = "30";
        this.changeSize1 = "70";
      } else {
        this.minMaxViewer = false;
        this.fullViewer = false;
        this.changeSize = "50";
        this.changeSize1 = "50";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hoverr:hover {
  box-shadow: 0 0 50px rgba(black, 1);
}
.splitpanes {
  background-color: #f2f2f2;

  &__pane {
    display: flex;
    justify-content: center;
    font-family: "Nunito Sans";
    color: rgba(255, 255, 255, 0.6);
    font-size: 1em;
  }

  &__splitter {
    background-color: #ccc;
    position: relative;
  }

  &__splitter:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: 0.4s;
  }
  &--vertical > &__splitter:before {
    left: -30px;
    right: -30px;
  }
  &--horizontal > &__splitter:before {
    top: -30px;
    bottom: -30px;
  }
  &__splitter:hover:before {
    background-color: rgba(255, 0, 0, 0.3);
  }
}
</style>